import { render, staticRenderFns } from "./t-link-button.vue?vue&type=template&id=7118b3ed"
import script from "./t-link-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./t-link-button.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports